import DialogCreateSubCategorySetttings from "@components/Dialog/CreateSubCategorySettings";
import DialogEditCategorySetttings from "@components/Dialog/EditSubCategorySettings";
import { ColumnLabel } from "@components/Table/Settings/Toolbar";
import { createSubCategories, editSubCategories, getAllSubCategories, inactivateSubCategories } from "@services/form";
import { useIntl } from "react-intl";
import { ISubcategoryResponse } from "@types";
import { useT, useLocalizedName } from "@hooks";
import SettingsCrudPage from "../SettingsCrudPage";
import useSettingsCrudPage from "../useSettingsCrudPage";

const defaultColumnOrder = ["categoryName", "name"];

const SubCategoriesPage = () => {
  const t = useT();
  const localizedName = useLocalizedName();
  const { locale } = useIntl();

  const crud = useSettingsCrudPage({
    translationPrefix: "settings.subcategory",
    reloadKey: locale,
    fetchService: getAllSubCategories,
    mountOption: (data: ISubcategoryResponse[]) =>
      data?.map((res) => ({
        id: res.id,
        categoryId: res.categoryId,
        name: localizedName(res),
        categoryName: res?.categoryName,
        date: "",
        active: res?.active,
        predefined: res?.predefined,
      })),
    createService: (value, selectCategory) => createSubCategories(selectCategory || "", { name: value }),
    editService: (selected, value) =>
      editSubCategories(String(selected.categoryId) || "", { id: selected.id, name: value }),
    inactivateService: inactivateSubCategories,
    buildEditSelection: (
      id: number,
      name: string,
      type?: string,
      expenseType?: string,
      categoryName?: string,
      categoryId?: number
    ) => ({
      id,
      name,
      categoryName,
      categoryId,
    }),
  });

  const columnLabels: ColumnLabel = {
    id: "1",
    categoryName: t("settings.subcategory.column.categoryName"),
    name: t("settings.subcategory.column.name"),
    date: "",
  };

  return (
    <SettingsCrudPage
      crud={crud}
      translationPrefix="settings.subcategory"
      columnLabels={columnLabels}
      defaultColumnOrder={defaultColumnOrder}
    >
      <DialogCreateSubCategorySetttings
        title={t("settings.subcategory.dialog.newTitle")}
        show={crud.createNewModal}
        placeholder={t("settings.subcategory.placeholder.new")}
        onClose={() => {
          crud.setCreateNewModal(false);
        }}
        onSave={crud.handleSaveNewOption}
        showDuplicateAlert={crud.showDuplicateAlert}
        duplicateAlertMessage={crud.duplicateAlertMessage}
        existingSubcategories={crud.options.map((o) => ({ name: o.name, categoryId: o.categoryId }))}
        duplicateNameMessage={t("settings.subcategory.notification.createDuplicate")}
      />

      <DialogEditCategorySetttings
        title={t("settings.subcategory.dialog.editTitle")}
        show={crud.editModal}
        placeholder={t("settings.subcategory.placeholder.edit")}
        onClose={() => {
          crud.setEditModal(false);
        }}
        onSave={(value: string) => crud.handleEditOption(value)}
        name={crud.optionSelected?.name}
      />
    </SettingsCrudPage>
  );
};

export default SubCategoriesPage;
